import 'react-app-polyfill/stable';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers/reducers';
import { initParams } from './reducers/params';
import { initProfiles } from './reducers/profiles';
import { initWebsites } from './reducers/websites';
import './index.css';
import App from './App';


initParams.apiUrl = `${process.env.REACT_APP_API_URL}`;
initParams.email = `${process.env.REACT_APP_DATASPAN_EMAIL}`;
initParams.token = `${process.env.REACT_APP_DATASPAN_TOKEN}`;

const query = window.location.search.split('?');
if (query.length > 1) {
  const params = query[1].split('&');
  if (params.length === 2) {
    initParams.email = params[0].split('=')[1];
    initParams.token = params[1].split('=')[1];
  }
}

if(initParams.token === '') {
  window.location.href = `${process.env.REACT_APP_OKTA_SSO}`;
}

ReactDOM.render(
    <Provider
      store={createStore(
        reducers,
        {
            params: initParams,
            profiles: initProfiles,
            websites: initWebsites,
        },
        applyMiddleware(thunk),
      )}
    >
      <App />
    </Provider>,
    document.getElementById('root'),
  );
